var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.request
    ? _c(
        "div",
        [
          _vm.request.includeSTEARightToInspection
            ? _c("div", { staticClass: "row mt-5" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("span", {
                    attrs: { id: "inspection-info" },
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("MaterialRequest.Info"))
                    }
                  })
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("h2", [_vm._v(_vm._s(_vm.$t("MaterialRequest.AttachmentsInfo")))]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("span", { staticClass: "preformatted" }, [
                _vm._v(_vm._s(_vm.request.requestText))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("attachment-table", {
            attrs: {
              title: "Attachment.Attachments",
              showActions: true,
              required: true,
              createNewAttachment: _vm.createNewAttachment,
              allowDelete: function() {
                return true
              }
            },
            model: {
              value: _vm.request.attachments,
              callback: function($$v) {
                _vm.$set(_vm.request, "attachments", $$v)
              },
              expression: "request.attachments"
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }